import { render, staticRenderFns } from "./CheckboxButton.vue?vue&type=template&id=5f3a1b84&"
import script from "./CheckboxButton.vue?vue&type=script&lang=js&"
export * from "./CheckboxButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports